import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Logo } from '@/components/Logo';
import { isSupabaseConfigured } from '@/lib/supabase';
import { AlertTriangle, Eye, EyeOff } from 'lucide-react';
import { LegalLinks } from '@/components/legal/LegalShell';

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_60%_50%_at_50%_0%,rgba(255,165,0,0.12),transparent_60%)]" />
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Logo variant="full" className="h-16" /></div>
        <div className="card-surface p-8">
          <h1 className="font-display text-2xl font-bold text-white">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
          {!isSupabaseConfigured && (
            <div className="mt-4 flex items-start gap-2 rounded-xl border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive" data-testid="supabase-not-configured">
              <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
              <span>Authentification non configurée. Ajoute REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_PUBLISHABLE_KEY.</span>
            </div>
          )}
          <div className="mt-6">{children}</div>
        </div>
        {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
        <div className="mt-4 flex flex-col items-center gap-3 text-center">
          <Link to="/" className="text-xs text-muted-foreground hover:text-white">← Retour à l'accueil</Link>
          <LegalLinks className="justify-center" />
        </div>
      </div>
    </div>
  );
}

export const authInput = 'w-full rounded-xl border border-border bg-surface-input px-4 py-3 text-white placeholder:text-muted-foreground focus:border-brand/60 focus:outline-none';
export const authButton = 'w-full rounded-full bg-brand py-3 font-semibold text-black btn-glow transition-transform hover:scale-[1.01] disabled:opacity-60';

// Password field with a show/hide eye toggle. Never alters the entered value.
export function PasswordInput({ 'data-testid': testId, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input {...props} type={show ? 'text' : 'password'} className={`${authInput} pr-12`} data-testid={testId} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
        data-testid={testId ? `${testId}-toggle` : 'password-toggle'}
        className="absolute right-3 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full text-muted-foreground hover:text-white"
      >
        {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
}
